// extracted by mini-css-extract-plugin
export default {"VerifyEmail":"VerifyEmail_VerifyEmail__u59rT"};